<template>
    <div>
        <nav v-if="pages.length > 1" aria-label="Page navigation">
            <ul class="pagination">
                <li @click="clickedPrePageGroup">
                    <a href="#" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                <li v-for="page in pages" :class="{ active: current_page === page }" @click="clickedPageLink(page)"><a href="#">{{ page + 1 }}</a></li>
                <li @click="clickedNextPageGroup">
                    <a href="#" aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    export default {
        name: "pagination",
        props: ['totalArticle', 'baseUrl'],
        data() {
            return {
                total: 0,
                current_page: 0,
                path: '',
                per_page: 16,
                show_page_count: 10,
            }
        },
        created() {
            console.log("### " + this.totalArticle);

            if (this.totalArticle !== undefined) {
                this.total = this.totalArticle;
            }

            this.path = this.baseUrl;
        },
        computed: {
            start_page_of_group() {
                return parseInt(this.current_page / this.show_page_count) * this.show_page_count;
            },
            end_page() {
                return Math.ceil(this.total / this.per_page);
            },
            pages() {
                let start = this.start_page_of_group;
                let end = start + this.show_page_count < this.end_page ? start + this.show_page_count : this.end_page;
                return _.range(start, end)
            }
        },
        watch: {
            // total 값이 ProjectList에서 비동기로 넘어 오기 때문에 초반에 싱크가 되지 않는다.
            // watch 를 이용해서 ProjectList에서 요청이 끝나면 다시 적용될 수 있게 한다.
            totalArticle(new_total, old_total) {
                this.total = new_total;
            }
        },
        methods: {
            clickedPageLink(page) {
                this.current_page = page;
                this.$emit('update:page', page);
            },
            clickedPrePageGroup() {
                if (parseInt(this.current_page / this.show_page_count) > 0) {
                    this.clickedPageLink(Math.floor((this.current_page - 10) / 10 ) * 10);
                }
            },
            clickedNextPageGroup() {
                if (this.end_page > 0 && this.pages.indexOf(this.end_page - 1) == -1) {
                    this.clickedPageLink(Math.floor((this.current_page + 10) / 10 ) * 10);
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/Pagination.vue